import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    root: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    noMargin: {
        margin: 0,
    },
});

const Paragraph = ({ classes, noMargin, className, children }) => (
    <Typography
        variant="body1"
        className={classNames(
            classes.root,
            {
                [classes.noMargin]: noMargin,
            },
            className
        )}
    >
        {children}
    </Typography>
);

Paragraph.propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    noMargin: PropTypes.bool,
};
Paragraph.defaultProps = {
    noMargin: false,
};

export default withStyles(styles)(Paragraph);
